module.exports = __webpack_public_path__ + "static/media/unescapesql.ca236423.svg";